export default {"src":"/_next/static/media/logo.bd7a944d.svg","height":231,"width":469,"blurWidth":0,"blurHeight":0};